<template>
    <div class="select page">
        <wrapper
            column
            align="flex-start"
            :backgroundImage="require('@/assets/main-bg.jpg')"
        >
            <div class="float image-container">
                <img
                    src="@/assets/Stage/Comics/common/top.webp"
                    alt=""
                    width="100%"
                />
                <div class="text">
                    <div class="type">不猶豫翻翻樂</div>
                    <div class="header">關卡選擇</div>
                </div>
            </div>
            <BackBtn />
            <div class="main">
                <level-grid
                    class="levels"
                    @click="startLevel"
                    :passLevels="passComics"
                />
                <div class="hint">
                    <div>
                        <span>＊ 已破關卡標示：</span>
                        <img src="@/assets/Stage/Comics/home/icon-mark.png" />
                    </div>
                </div>
            </div>
            <div class="float-footer image-container">
                <img
                    src="@/assets/Stage/Comics/common/footer.webp"
                    alt=""
                    width="100%"
                />
            </div>
            <div class="comic-dialog" v-if="showGuestLoginDialog">
                <div class="text">
                    登入LINE即可<br />
                    儲存通關紀錄
                </div>
                <rect-btn
                    shadow-color="rgba(171, 203, 216, 0.5)"
                    background-color="#daf0ff"
                    max-height="130px"
                    min-height="90px"
                    width="90%"
                    font-size="1.8rem"
                    @click="login"
                >
                    <div class="button-content">
                        <img src="@/assets/Login/line.png" alt="" />
                        <div class="text">LINE 登入</div>
                    </div>
                </rect-btn>
                <div
                    class="button-content"
                    v-if="guestPlayTimes < 2"
                    @click="closeDialog = true"
                >
                    <div class="text normal">繼續</div>
                </div>
            </div>
        </wrapper>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import PageGeneral from '@/mixins/PageGeneral';
import BackBtn from '@/components/Button/BackButton.vue';
import LevelGrid from '@/components/Comics/LevelGrid.vue';

export default {
    mixins: [PageGeneral],
    components: { BackBtn, LevelGrid },
    data: () => ({
        closeDialog: false,
    }),
    computed: {
        ...mapState({
            user: (state) => state.user,
        }),
        ...mapState('comics', ['guestPlayTimes']),
        ...mapGetters('comics', ['passComics', 'showGuestLogin']),
        showGuestLoginDialog() {
            return this.showGuestLogin && !this.closeDialog;
        },
    },
    methods: {
        ...mapActions(['login']),
        startLevel(level) {
            if (!this.showGuestLoginDialog) {
                this.$router.push({ name: 'Stage_Comics', params: { level } });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/main.scss";
@import "@/scss/comic-dialog.scss";
.select {
    .image-container.float {
        position: relative;
        .text {
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .header {
                font-size: 2em;
                font-weight: bold;
            }
        }
    }
    .levels {
        padding: 0px 10px;
    }
    .hint {
        &::before {
            content: "";
            height: clamp(10px, 30%, 40px);
            width: 10px;
            display: block;
        }
        flex: 1;
        font-size: 15px;
        color: #235194;
        > div {
            display: inline-flex;
            align-items: center;
            img {
                width: 20px;
                height: 20px;
            }
        }
    }
    .comic-dialog {
        font-size: 1.5em;
        font-weight: bold;
        padding: 20px 0;
        width: calc(100%-50px);
        top: 50%;
        max-width: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        > .text {
            // color: #fff;
            margin-bottom: 20px;
        }
        .button-content {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                margin: 0 15px;
                width: 70px;
                height: 70px;
                border-radius: 50%;
            }
            .text {
                margin-right: 15px;
                &.normal {
                    padding: 10px 5px;
                    color: #777;
                    font-size: 0.8em;
                    cursor: pointer;
                }
            }
            &:not(:first-of-type) {
                margin-top: 10px;
            }
        }
    }
}
</style>
